/**
 * THE RENDERED CLOSERS.
 *
 * The animated tail every clip ends on, in both video shapes. These are the
 * source files — not something the page draws — so they are listed here as
 * plain URLs and handed over as-is; re-encoding them through the export
 * machinery would only lose a generation of quality.
 *
 * The still end card on this page is the same lockup frozen, so a clip that
 * cannot carry a video tail (a thumbnail, a slide, a static post) still lands
 * on the same address.
 */
export type VideoCloser = {
  id: string;
  name: string;
  note: string;
  use: string;
  ratio: '9:16' | '16:9';
  src: string;
};
export const VIDEO_CLOSERS: VideoCloser[] = [{
  id: 'closer-9x16',
  name: 'Closer, vertical',
  note: '9:16 · MP4',
  use: 'The tail for anything cut for a phone — Shorts, Reels, TikTok, a story. Butt it against the last frame of your footage; it carries its own hold at the end.',
  ratio: '9:16',
  src: 'https://cdn.magicpatterns.com/uploads/oW15BtRYf1ihu4VzcB3aQt/9x16_Video Closer.mp4'
}, {
  id: 'closer-16x9',
  name: 'Closer, landscape',
  note: '16:9 · MP4',
  use: 'The tail for YouTube, a site embed, or anything played on a desktop. Same lockup and timing as the vertical one, recomposed for the wider frame.',
  ratio: '16:9',
  src: 'https://cdn.magicpatterns.com/uploads/8YHa5Y5VoKt2Z7QEMFJXrd/16x9_Video Closer (2).mp4'
}];
